import { InputText } from "primereact/inputtext";

const AIEduInputTextFixedLabel = (props) => {
    return (
        <>
            <InputText {...props} />
        </>
    );
};

export default AIEduInputTextFixedLabel;
